import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  AddTranslationTaskParams,
  AddTranslationTaskResponse,
  DeleteTranslationTaskParams,
  DownloadAllTranslatedFilesParams,
  EditTranslationTaskNamePayload,
  EditTranslationTaskNameResponse,
  EditTranslationTaskParams,
  GetDetailTranslationTaskParams,
  GetDetailTranslationTaskResponse,
  GetListLanguagesResponse,
  GetTranslationTasksParams,
  GetTranslationTasksResponse,
} from './translation.type';
import { request } from '../configs/axiosConfig';

export const TranslationService = {
  getListLanguages: async () => {
    return request<GetListLanguagesResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_LIST_LANGUAGES,
    });
  },
  getDetailTranslationTask: async (params: GetDetailTranslationTaskParams) => {
    return request<GetDetailTranslationTaskResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_DETAIL_TRANSLATION_TASK,
      params,
    });
  },
  getTranslationTasks: async (params: GetTranslationTasksParams) => {
    return request<GetTranslationTasksResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_TRANSLATION_TASKS,
      params,
    });
  },
  editTranslationTaskName: async (data: EditTranslationTaskNamePayload) => {
    return request<EditTranslationTaskNameResponse>({
      method: HTTPMethod.PUT,
      url: ENDPOINT.EDIT_TRANSLATION_TASK_NAME,
      data,
    });
  },
  deleteTranslationTask: async (params: DeleteTranslationTaskParams) => {
    return request({
      method: HTTPMethod.DELETE,
      url: ENDPOINT.DELETE_TRANSLATION_TASKS,
      params,
    });
  },
  addTranslationTask: async (data: AddTranslationTaskParams) => {
    return request<AddTranslationTaskResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.ADD_TRANSLATION_TASK,
      data,
    });
  },
  editTranslationTask: async (data: EditTranslationTaskParams) => {
    return request({ method: HTTPMethod.PUT, url: ENDPOINT.EDIT_TRANSLATION_TASK, data });
  },
  downloadAllTranslatedFiles: async (params: DownloadAllTranslatedFilesParams) => {
    return request<Blob>({
      method: HTTPMethod.GET,
      responseType: 'blob',
      url: ENDPOINT.DOWNLOAD_TRANSLATED_FILES,
      params,
    });
  },
};
